import React from 'react';
import './Footer.scss';
import { useContentful } from '../contentful/ContentContext';

const InstagramLogoComponent = () => {
  return (
    <svg
      className={'instagramLogo'}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 169.1 169.1">
      <path d="M122.4 0H46.7C20.9 0 0 21 0 46.7v75.7c0 25.7 21 46.7 46.7 46.7h75.7c25.7 0 46.7-21 46.7-46.7V46.7C169 20.9 148 0 122.4 0zm31.7 122.4a31.7 31.7 0 0 1-31.7 31.7H46.7A31.7 31.7 0 0 1 15 122.4V46.7A31.7 31.7 0 0 1 46.7 15h75.7a31.7 31.7 0 0 1 31.7 31.7v75.7z" />
      <path d="M84.5 41a43.6 43.6 0 1 0 .1 87.2 43.6 43.6 0 0 0 0-87.2zm0 72a28.6 28.6 0 1 1 0-57.1 28.6 28.6 0 0 1 0 57.2zM130 28.3a11 11 0 0 0-11 11 11 11 0 0 0 11 11 11 11 0 0 0 7.8-18.8 11 11 0 0 0-7.9-3.2z" />
    </svg>
  );
};

const Footer = () => {
  const { getUiText } = useContentful();

  return (
    <footer>
      <div className={'footerTop'}></div>

      <div className={'footerInner'}>
        <div className={'footerBrand'}>
          <span className={'footerSiteName'}>{getUiText('UI.SiteTitle')}</span>
          <span className={'footerCopy'}>© {new Date().getFullYear()}</span>
        </div>

        <div className={'footerLinks'}>
          <p>{getUiText('UI.FooterText')}</p>
          <div className={'footerLinkRow'}>
            <div className={'item'}>
              <a
                target="_blank"
                className={'link'}
                href={`https://www.instagram.com/urjordkeramik/`}
                rel="noreferrer">
                <InstagramLogoComponent />
                {getUiText('UI.InstagramLinkText')}
              </a>
            </div>

            <div className={'item'}>
              <a href={`mailto:${getUiText('UI.EmailAdress')}`}>
                {getUiText('UI.EmailAdress')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
